export default __webpack_public_path__ + "static/media/Bezel_Brown_Sand.3a22fe35.png";